// extracted by mini-css-extract-plugin
export default {"popper":"Popper_popper__ebADC","bridge":"Popper_bridge__+lfld"};